export default __webpack_public_path__ + "static/media/txt.6d240193.svg";